import * as React from 'react';

type UseDelayedMount = ({
  delay,
  onChange,
  onMounted,
}: {
  delay: number;
  onChange: any;
  onMounted(): void;
}) => boolean[];

export const useDelayedMount: UseDelayedMount = ({
  onMounted,
  delay,
  onChange,
}) => {
  const [isMounted, setIsMounted] = React.useState(false);

  React.useEffect(() => {
    setIsMounted(false);

    const timeoutId = setTimeout(() => {
      onMounted();
      setIsMounted(true);
    }, delay);
    return () => clearTimeout(timeoutId);
  }, [onChange]);

  return [isMounted];
};
